// Module
var code = "<div class=\"row\" style=\"padding: 0 20px;\">\n    <dashboard></dashboard>\n</div>\n";
// Exports
module.exports = code;